export default "__VITE_ASSET__Bkffq43i__"